import type { DocPage } from "../types";

export const page: DocPage = {
  slug: "account",
  title: "Account and settings",
  navLabel: "Account",
  description:
    "Manage your profile, preferences, plan, credits, connections, notifications, privacy, and account security.",
  section: "account",
  published: "2026-08-03",
  updated: "2026-08-03",
  related: ["getting-started", "accounts", "mcp"],
  blocks: [
    {
      type: "lead",
      text: "Settings brings your identity, Agent preferences, plan, connections, notifications, and privacy controls together. On mobile, open **Me** and use the Settings button; on desktop, open Settings from the account menu.",
    },

    { type: "h2", text: "Profile and preferences" },
    {
      type: "p",
      text: "Under **Account**, update the display name shown in Mavori and to the Agent. **About you** stores your investment style, preferred assets, and AI-agent experience so research and explanations can begin at the right level. **Preferences** controls product analytics, while **Appearance** lets you use the system theme or choose light or dark mode. **Rules & Memory** is where you review standing guidance and remembered facts that carry across conversations.",
    },

    { type: "h2", text: "Plan, credits, and billing" },
    {
      type: "p",
      text: "Open **Billing** to see your current plan, included AI credits, and the features available on each plan. You can start or change a plan, manage an existing subscription, and buy additional credits when that option is available. Included credits renew on the cadence shown beside your plan; the credit balance in the account menu gives you the quickest current view.",
    },

    { type: "h2", text: "Connections and notifications" },
    {
      type: "p",
      text: "Use **Connections** for brokerages that provide portfolio context or permissioned trading. The separate [MCP connections](/docs/mcp) page manages external AI clients and tool servers. Under **Notifications**, choose which approval requests, risk events, fired alerts, and daily digests should reach you, then manage the browsers and mobile devices registered to receive them.",
    },

    { type: "h2", text: "Data plugins" },
    {
      type: "p",
      text: "Open **Data plugins** to see the research, news, market, options, portfolio, backtest, and macro data families enabled for your account. This view explains what each family contributes; source, freshness, and coverage still travel with the result that uses it. See [Data coverage and freshness](/docs/data) for how to read those states.",
    },

    { type: "h2", text: "Security, privacy, and support" },
    {
      type: "p",
      text: "**Security & Privacy** shows your email status and sign-in methods, and lets eligible accounts update an email or password. You can download a copy of your account data or permanently delete the account from the same area. Review the [Privacy Policy](/legal/privacy) and [Terms of Service](/legal/terms) for the legal details. If you need help with access, billing, or account data, use the [Contact page](/contact) to reach the appropriate support channel.",
    },
  ],
};
